<template>
  <div class="charge_wrap" @scroll="handleScroll" >
    <div class="charge_item" v-for="item in drawMoneyList" >
      <div class="item_head" >
        <div>订单号：{{ item.drawId }}</div>
        <div class="success" v-if="item.type === '1'" >{{ item.typeStr }}</div>
        <div class="pending" v-if="item.type === '0'" >{{ item.typeStr }}</div>
        <div class="fail" v-if="item.type === '2'" >{{ item.typeStr }}</div>
      </div>
      <div class="bank_info" >{{ item.cardInfo }}</div>
      <div class="item_footer" >
        <div>{{ item.createTime }}</div>
        <div>-{{ item.drawMoney }}</div>
      </div>
    </div>
    <van-empty description="暂无数据" v-if="!loading && drawMoneyList.length <=0" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getDrawMoneyVoListByPage } from '@/api/account'
export default {
  name: 'chargeList',
  data() {
    return {
      page: 1,
      pageSize: 15,
      drawMoneyList: [],
      loading: false
    }
  },
  methods: {
    handleScroll(e) {
      const {scrollTop, clientHeight, scrollHeight} = e.target
      if (scrollTop + clientHeight >= scrollHeight - 50){
        this.page++
        this.getDrawMoneyVoListByPage()
      }
    },
    getDrawMoneyVoListByPage() {
      const { page, pageSize } = this
      this.loading = true
      getDrawMoneyVoListByPage({ page, pageSize }).then(res => {
        console.log(res)
        this.loading = false
        if(res.success) {
          this.drawMoneyList = this.drawMoneyList.concat(res.data)
        }
      })
    }
  },
  mounted() {
    this.getDrawMoneyVoListByPage()
  },
}
</script>
